import Vue from 'vue';


Vue.prototype.$VUE_APP_SWAGGER_URL = process.env.VUE_APP_SWAGGER_URL;
Vue.prototype.$VUE_APP_GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;
Vue.prototype.$VUE_APP_SECRET_KEY = process.env.VUE_APP_SECRET_KEY;
Vue.prototype.$VUE_APP_SECRET_ACCESS_LIST = process.env.VUE_APP_SECRET_ACCESS_LIST;
